import State, { getActivityForDay } from './state'
import audioManager from '@/scripts/audio/audioManager'
import slides from './slides'
import analytics, { ACTION_ACTIVITY_HOVER } from '@/scripts/analytics'

function getCurrentSlide() {
  if (!State.embla) return null
  const idx = State.embla.selectedScrollSnap()
  return idx !== undefined && idx >= 0 && idx < slides.Slides.length ? slides.Slides[idx] : null
}

function setPhase(phase: 1 | 2) {
  const cur = getCurrentSlide()
  if (!cur) return
  if (phase === 1) {
    cur.itemP1.classList.remove('invisible')
    cur.itemP2.classList.add('invisible')
  } else {
    cur.itemP1.classList.add('invisible')
    cur.itemP2.classList.remove('invisible')
  }
  State.phase = phase
}

function initPhaseTapDelegation(root: HTMLElement) {
  root.addEventListener(
    'click',
    (e: MouseEvent) => {
      if (!State.embla) return

      const target = e.target as HTMLElement | null
      if (target?.closest('.mobile-container__btn, .modal')) return

      const r = State.refs.phaseArea!.getBoundingClientRect()
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom
      if (!inside) return

      const idx = State.embla.selectedScrollSnap()
      const cur = slides.Slides[idx]
      if (!cur) return

      const showingP1 = !cur.itemP1.classList.contains('invisible')

      if (showingP1) {
        setPhase(2)

        const currentDay = State.day
        const act = getActivityForDay(State.day)

        if (act?.linkHash) {
          analytics.sendCustomEvent(ACTION_ACTIVITY_HOVER, act.linkHash)
        }

        // Play sound if activity exists and has positionId
        if (act?.positionId) {
          audioManager.playItemSfx(act.positionId, () => {
            if (State.day !== currentDay) return
            setPhase(1)
          })
        }
      } else {
        audioManager.stopItemSfx(500)
        setPhase(1)
      }
    },
    { passive: true },
  )
}

function resetPhase() {
  audioManager.stopItemSfx(500)
  setPhase(1)
}

export default { initPhaseTapDelegation, resetPhase }
